<div
  class="panel-container"
  [class.multi-selection]="panel.selectedItemIds?.size"
>
  <div
    (click)="opened.next()"
    class="panel-header"
    [class.hide-section]="panel?.wizardImports && !panel.list?.length"
  >
    <div class="panel-header-content">
      @if (panel.parentType && panel.parentType !== 'course') {
      <button mat-icon-button class="back-button" (click)="back()">
        <mat-icon>arrow_back</mat-icon>
      </button>
      }
      <div class="panel-header-text" data-cy="panelHeaderText">
        {{ panel.translations.header }}
        @if (panel?.showTotalItems) { ({{ panel?.list?.length || 0 }}) }
      </div>

      @if (isOpen) { @if (panel.sortingActions) {
      <div class="panel-selection-sorting">
        <button
          [matMenuTriggerFor]="sortMenu"
          color="primary"
          mat-icon-button
          type="button"
        >
          <mat-icon>{{ panel?.selectedSortAction.icon }}</mat-icon>
          <span>{{ panel?.selectedSortAction.text }}</span>
        </button>
        <button
          (click)="sortList()"
          color="primary"
          mat-icon-button
          type="button"
          data-cy="addButton"
        >
          <mat-icon>
            {{
              panel?.selectedSortAction?.sort.direction === 'ASC'
                ? 'north'
                : 'south'
            }}
          </mat-icon>
        </button>
        <mat-menu
          class="content-sorting-menu"
          [overlapTrigger]="true"
          #sortMenu="matMenu"
        >
          @for (item of panel.sortingActions; track $index; let i = $index) {
          <div (click)="changeSort(item)" mat-menu-item>
            <mat-icon>{{ item.icon }}</mat-icon>
            {{ item.text }}
          </div>
          }
        </mat-menu>
      </div>
      }
      <div class="panel-header-actions">
        @if (panel.headerActions) { @for (action of panel.headerActions; track
        $index) {
        <button
          [matTooltip]="action.text"
          (click)="action.onClick(pathToThisPanel(), panel.list)"
          color="primary"
          mat-icon-button
          type="button"
        >
          <mat-icon>{{ action.icon }}</mat-icon>
        </button>
        } } @if(panel?.wizardImports){
        <qa-button
          [isRaisedButton]="true"
          [disabled]="panel.doNotshowAdd"
          [isIconButton]="true"
          [isRoundedButton]="true"
          icon="add"
          type="button"
          data-cy="addButton"
          (submitted)="openAddContentDialog()"
        ></qa-button>
        } @else { @if (panel.addMenuItems?.length) {
        <qa-button
          [matMenuTriggerFor]="addMenu"
          [matTooltip]="panel.translations.addItem"
          [isRaisedButton]="true"
          [disabled]="panel.doNotshowAdd"
          [isIconButton]="true"
          [isRoundedButton]="true"
          icon="add"
          type="button"
          data-cy="addButton"
          #addButton
        ></qa-button>
        <mat-menu
          class="content-menu"
          [overlapTrigger]="true"
          #addMenu="matMenu"
        >
          @for (item of panel.addMenuItems; track $index; let i = $index) { @if
          (i == 0) {
          <button
            (click)="item.onClick()"
            mat-menu-item
            type="button"
            data-cy="createNewItem"
          >
            <mat-icon>{{ item.icon }}</mat-icon>
            {{ item.text }}
          </button>
          } @if ( panel?.imports?.length && panel.addMenuItems?.length === 1 ) {
          <button
            (click)="importContent()"
            data-cy="addItem"
            mat-menu-item
            type="button"
          >
            <mat-icon>file_upload</mat-icon>
            {{ getTitle() }}
          </button>
          } } @if ((panel.addMenuItems?.length ?? 0) > 1) {
          <div class="import-list" mat-menu-item>
            <mat-label>{{ 'common.label.import' | translate }}</mat-label>
            <div class="container">
              <div class="item-list">
                @for (item of panel.addMenuItems; track $index; let i = $index)
                { @if (i == 0) {
                <div class="item">
                  <div class="item-label">&nbsp; &nbsp;</div>
                </div>
                } @if (i > 0) {
                <div class="item">
                  <div class="item-label" (click)="item.onClick()">
                    <mat-icon>{{ item.icon }}</mat-icon>
                    {{ item.text }}
                    @if (item?.coming_soon) {
                    <div class="newicon">
                      {{ 'menu.soon' | translate }}
                    </div>
                    } @if (item?.beta) {
                    <div class="newicon">
                      {{ 'menu.beta' | translate }}
                    </div>
                    }
                  </div>
                </div>
                } }
              </div>
            </div>
          </div>
          }
        </mat-menu>
        } }
      </div>
      }
    </div>
  </div>

  <div
    class="panel-body"
    [ngClass]="{
      'is-filteredList': panel?.filteredList?.length,
      'has-wizard-imports': panel?.wizardImports && !panel?.list?.length
    }"
  >
    <ng-scrollbar>
      <div @fade class="panel-body-content">
        <div class="panel-body-top-list">
          <ng-container
            [ngTemplateOutlet]="listTemplate"
            [ngTemplateOutletContext]="{
              list: panel.list,
              itemActions: panel.itemActions,
              itemOnHoverActions: panel.itemOnHoverActions,
              multiSelect: true,
              isFilteredlist: false
            }"
          >
          </ng-container>
        </div>
      </div>
    </ng-scrollbar>
  </div>

  <ng-template
    #listTemplate
    let-list="list"
    let-itemActions="itemActions"
    let-itemOnHoverActions="itemOnHoverActions"
    let-multiSelect="multiSelect"
    let-isFilteredlist="isFilteredlist"
  >
    @if (!list || list.length < 1) {
    <div class="wizard-wrapper" [class.hide-section]="!panel?.wizardImports">
      <div class="wizard-wrapper-title">
        {{
          'content.wizardActions.description.noContent'
            | translate : { name: panel.translations.header | lowercase }
        }}
      </div>
      <div class="wizard-wrapper-description">
        {{ 'content.wizardActions.description.wantToCreate' | translate }}
      </div>
      <qa-add-content-wizard
        [wizardImports]="panel?.wizardImports"
      ></qa-add-content-wizard>
    </div>
    <div class="no-content" [class.hide-section]="panel?.wizardImports">
      <mat-icon>manage_search</mat-icon>
      <p>
        {{ 'common.list.noContent' | translate }}
        {{ panel.translations.header }}.
      </p>
      @if (!list?.length) {
      <div class="btn-container">
        <qa-button
          [isRaisedButton]="true"
          (submitted)="panel.addMenuItems[0].onClick()"
          label="common.button.createNew"
          icon="add"
          [minWidth]="200"
          [showIconAtEnd]="true"
          data-cy="createNew"
        ></qa-button>
        <qa-button
          [isRaisedButton]="true"
          (submitted)="importContent()"
          label="common.button.add"
          icon="file_upload"
          [minWidth]="200"
          [showIconAtEnd]="true"
        ></qa-button>
      </div>
      } @if (panel?.showChatGptAction) {
      <div class="chat-gpt" (click)="openGPT()">
        <img src="assets/icons/chat-gpt.svg" alt="gpt" />
        <div>{{ 'chatgptImports.title' | translate }}</div>
        <mat-icon>chevron_right</mat-icon>
      </div>
      }
    </div>
    } @if (list?.length) {
    <mat-list
      (cdkDropListDropped)="afterItemDrop($event, list)"
      cdkDropList
      cdkDropListLockAxis="y"
    >
      <mat-list-item
        [class.notChangeItemPosition]="!panel.changeItemPosition"
        class="panel-list-item list-item-header"
      >
        <span matListItemTitle>
          @if (panel.changeItemPosition && !isFilteredlist) {
          <mat-icon></mat-icon>
          }
          <mat-checkbox
            class="check-all"
            [indeterminate]="someChecked"
            [checked]="isAllChecked"
            (change)="selectAll($event.checked)"
            color="primary"
          >
          </mat-checkbox>
          <div class="item-position"></div>
          <div class="item-text">{{ panel?.itemHeaderText | translate }}</div>
          <div class="item-suffixes"></div>
          <div class="actions-row">
            @if (panel?.itemHeaderActionText) {
            <div class="item-actions">
              {{ panel?.itemHeaderActionText | translate }}
            </div>
            }
          </div>
        </span>
      </mat-list-item>
      <div
        class="panel-list-wrapper"
        [class.isSelected]="panel.selectedItemIds?.size > 0"
        [style.height.px]="list.length * LIST_ITEM_HEIGHT"
      >
        <ng-scrollbar>
          @for (item of list; track item.id; let i = $index) {
          <mat-list-item
            (click)="onItemClick(item)"
            [cdkDragData]="item"
            class="panel-list-item"
            [cdkDragDisabled]="!panel.changeItemPosition || isFilteredlist"
            [class.current]="isCurrentItem(panel, item)"
            [class.selected]="panel.selectedItemIds?.has(item.id)"
            [class.notChangeItemPosition]="!panel.changeItemPosition"
            [class.selectedEntity]="selectedItem?.id === item.id"
            [title]="item[panel.itemTextProperty]"
            data-cy="panelListItem"
            cdkDrag
            matRipple
          >
            @if (panel.changeItemPosition && !isFilteredlist) {
            <mat-icon cdkDragHandle class="drag-indicator"
              >drag_indicator</mat-icon
            >
            }
            <div *cdkDragPlaceholder class="drag-placeholder"></div>
            @if (panel.selectedItemActions && multiSelect) {
            <mat-checkbox
              (change)="
                $event.checked
                  ? panel.selectedItemIds.add(item.id)
                  : panel.selectedItemIds.delete(item.id)
              "
              (click)="$event.stopPropagation()"
              [checked]="panel.selectedItemIds.has(item.id)"
              color="primary"
            >
            </mat-checkbox>
            }
            <div class="item-position">
              {{ i + 1 }}
            </div>
            <div class="item-text">
              @if (item?.ref_course_id || item?.isImported) {
              <mat-icon class="course-market-icon">shopping_cart</mat-icon>
              } @if (item?.available_for_coursemarket) {
              <mat-icon class="course-market-icon">ios_share</mat-icon>
              } @if (item.itemPrefix) { @for (suffix of item.itemPrefix; track
              suffix) {
              <div class="item-suffix">
                @if (suffix.icon) {
                <mat-icon class="material-icons">{{ suffix.icon }}</mat-icon>
                } @if (suffix.text) {
                <span class="question-type-short">{{ suffix.text }}</span>
                }
              </div>
              } }
              <span>{{ item[panel.itemTextProperty] }}</span>
            </div>
            <div class="item-suffixes">
              @if (panel.itemSuffixes) { @for (suffix of
              panel.itemSuffixes(item); track $index) {
              <div class="item-suffix">
                @if (suffix.icon) {
                <mat-icon class="material-icons">{{ suffix.icon }}</mat-icon>
                } @if (suffix.text) {
                {{ suffix.text }}
                }
              </div>
              } }
            </div>
            <div class="actions-row">
              @if (itemOnHoverActions?.length) {
              <div class="item-appears-on-hover">
                @for (action of itemOnHoverActions; track $index; let j =
                $index) {
                <div [matTooltip]="action.tooltip && action.tooltip(item)">
                  @if (!(action.hidden && action.hidden(item))) {
                  <button
                    (click)="
                      action.onClick(item);
                      $event.stopPropagation();
                      $event.preventDefault()
                    "
                    [disabled]="action.disabled && action.disabled(item)"
                    mat-menu-item
                    type="button"
                    [attr.data-cy]="action.label"
                  >
                    <mat-icon>{{ action.icon }}</mat-icon>
                  </button>
                  }
                </div>
                }
              </div>
              } @if (itemActions?.length) {
              <div class="item-actions">
                @if (panel?.activateItemAction) {
                <qa-form-field-toggle
                  (click)="$event.stopPropagation()"
                  (valueChanged)="toggleActive(item)"
                  [checked]="panel?.isItemActive(item)"
                >
                </qa-form-field-toggle>
                }
                <qa-mat-menu-button
                  [menu]="itemActionMenu"
                  data-cy="itemActionMenu"
                ></qa-mat-menu-button>
                <mat-menu class="content-menu" #itemActionMenu="matMenu">
                  @for (action of itemActions; track $index; let j = $index) {
                  <div [matTooltip]="action.tooltip && action.tooltip(item)">
                    @if (!(action.hidden && action.hidden(item))) {
                    <button
                      (click)="action.onClick(item)"
                      [disabled]="action.disabled && action.disabled(item)"
                      mat-menu-item
                      [attr.data-cy]="action.label"
                      type="button"
                    >
                      <mat-icon>{{ action.icon }}</mat-icon>
                      {{ action.label }}
                    </button>
                    }
                  </div>
                  }
                </mat-menu>
              </div>
              }
            </div>
            @if (selectedItem?.id === item.id) {
            <mat-icon
              (click)="deselectEntity($event)"
              class="item-chevron-right"
            >
              chevron_right
            </mat-icon>
            }
          </mat-list-item>
          }
        </ng-scrollbar>
      </div>
    </mat-list>
    } @if (panel.selectedItemIds?.size) {
    <div @fade class="panel-selection-header">
      <div class="panel-header-contents">
        <button
          (click)="panel.selectedItemIds.clear()"
          mat-icon-button
          type="button"
        >
          <mat-icon>clear</mat-icon>
        </button>
        <span
          >{{ panel.selectedItemIds.size + ' ' }}
          {{ getItemSelectedText(panel.selectedItemIds.size === 1) }}
        </span>
      </div>
      <div class="panel-selection-header-actions">
        @for (action of panel.selectedItemActions; track $index) {
        <qa-button
          [isRaisedButton]="true"
          [icon]="action.icon"
          [label]="action.label"
          [showIconAtEnd]="true"
          (submitted)="action.onClick(toArray(panel.selectedItemIds))"
        ></qa-button>
        }
      </div>
    </div>
    }
  </ng-template>
</div>
